export const getInitials = str => {
    const results = []
    const wordArray = str.split(' ')
    wordArray.forEach(e => {
        results.push(e[0])
    })
    return results.join('').toUpperCase()
};